import React from "react";
import Skills__range from "./Skills__range";
import ibtisam from '../images/ibtisam.png';
import CV from '../Resume/ibtisam__CV.pdf';
function Skills() {
  return (
   <div className="md:ml-[40px] md:mr-[40px] ml-2 mr-2 space-y-4">
       <h1 className="text-[2rem] font-bold mb-[40px]">My Skills</h1>
       <div className="md:flex md:flex-row md:justify-between flex flex-col ">
       <Skills__range title="Web Design" range={65}/>
       <Skills__range title="React Js" range={70}/></div>
       <div className="md:flex md:flex-row md:justify-between flex flex-col">
       <Skills__range title="JavaScript" range={50}/>
       <Skills__range title="Bootstrap" range={90}/>
       </div>  
      <p className="text-center pt-8 uk-animation-shake" uk-scrollspy="cls: uk-animation-shake; target: .uk-card; delay: 300; repeat: true"><a href={CV} download="Ibtisam Resume" style={{textDecoration:'none'}} className="px-7 py-3 uk-card border-1 border-black cursor:pointer hover:bg-black hover:text-white  " >Download CV</a></p>

   </div>
  );
}

export default Skills;
